// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/LeagueStagePanel.tsx
import { FunctionComponent } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { InfoCallout } from '../../components/InfoCallout';
import { SingleStageCard } from './SingleStageCard';

const PREFIX = 'pages.application_season.components.season_step2.callouts';

export const LeagueStagePanel: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={5}>
      <InfoCallout icon={<ChakraFeatherIcon name="zap" boxSize="18px" />}>
        <Text as="span" fontWeight="bold">
          {t(`${PREFIX}.league_prefix`)}
        </Text>{' '}
        {t(`${PREFIX}.league_text`)}
      </InfoCallout>
      <SingleStageCard />
    </Flex>
  );
};
